/**
 * Page Navigation Variant Controller
 * Reads page-level navigation variant settings and applies them
 */

(function () {
  'use strict';

  function applyPageNavVariant() {
    // Check for page metafield setting (highest priority)
    const pageNavMeta = document.querySelector('meta[name="page-nav-variant"]');
    if (pageNavMeta) {
      const variant = pageNavMeta.getAttribute('content');
      if (variant && (variant === 'transparent' || variant === 'white')) {
        updateNavVariant(variant);
        return;
      }
    }

    // Check for page section setting (from main-page section)
    const pageNavSetting = document.getElementById('page-nav-variant');
    if (pageNavSetting) {
      try {
        const data = JSON.parse(pageNavSetting.textContent);
        if (data.nav_variant && data.nav_variant !== 'auto') {
          updateNavVariant(data.nav_variant);
          return;
        }
      } catch (e) {
        // Silent fail
      }
    }
  }

  function updateNavVariant(variant) {
    const header = document.querySelector('.header');
    const headerWrapper = document.querySelector('.header-wrapper');

    if (!header || !headerWrapper) return;

    // Remove existing variant classes
    header.classList.remove('header--transparent', 'header--white');
    headerWrapper.classList.remove('header-wrapper--transparent', 'header-wrapper--white');

    // Add new variant class
    header.classList.add(`header--${variant}`);
    headerWrapper.classList.add(`header-wrapper--${variant}`);

    // Update logo color based on variant
    const logos = header.querySelectorAll('.beatswell-logo');
    logos.forEach((logo) => {
      if (variant === 'transparent') {
        logo.setAttribute('color', '#FFFFFF');
      } else {
        logo.setAttribute('color', '#231F20');
      }
    });

    // Initialize hover handler if variant is transparent
    if (variant === 'transparent') {
      setTimeout(initTransparentNavHover, 100);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPageNavVariant);
  } else {
    applyPageNavVariant();
  }

  // Also run after sections load (for Shopify theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', applyPageNavVariant);
  }
})();

/**
 * Transparent Navigation Hover Handler
 * Adds hover class to transparent header when hovering
 */
function initTransparentNavHover() {
  const headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;

  // Only apply to transparent headers
  if (!headerWrapper.classList.contains('header-wrapper--transparent')) return;

  // Prevent double initialization
  if (headerWrapper.dataset.hoverInitialized) return;
  headerWrapper.dataset.hoverInitialized = 'true';

  // Add hover class when hovering
  headerWrapper.addEventListener('mouseenter', () => {
    headerWrapper.classList.add('header-hover');
  });

  headerWrapper.addEventListener('mouseleave', () => {
    // Only remove if no mega-menu is open
    if (!headerWrapper.querySelector('.mega-menu[open]')) {
      headerWrapper.classList.remove('header-hover');
    }
  });
}

// Expose globally for variant controller
window.initTransparentNavHover = initTransparentNavHover;

// Set header height CSS variable for transparent header overlap
function setHeaderHeightVariable() {
  const headerWrapper = document.querySelector('.header-wrapper--transparent');
  if (!headerWrapper) return;

  const sectionHeader = headerWrapper.closest('.section-header');
  if (!sectionHeader) return;

  const headerHeight = sectionHeader.offsetHeight;
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(initTransparentNavHover, 200);
    setTimeout(setHeaderHeightVariable, 100);
  });
} else {
  setTimeout(initTransparentNavHover, 200);
  setTimeout(setHeaderHeightVariable, 100);
}

// Update on resize
window.addEventListener('resize', setHeaderHeightVariable);
